import React, { Component } from 'react'
import Categoria from '../../utils/categoria'
import Producto from '../../utils/producto'
import ProductCategoryComponent from './Component';
const cat = new Categoria()
const prod = new Producto()

export default class Category extends Component {
    constructor() {
        super()
        this.state = {
            categoria: null,
            productos: []
        }
        this.leerProductos = this.leerProductos.bind(this)
    }

    leerCategoria() {
        const _this = this
        const params = {
            Descripcion: this.props.categoria
        }
        cat.getCategoria(params).then(categoria => {
            _this.setState({
                categoria
            })
            _this.leerProductos(categoria.Descripcion_lower)
            _this.props.loadCategoriaDetalle(categoria.Detalle)
        }).catch(error => console.error(error))
    }

    leerProductos(categoria) {
        const _this = this
        prod.leerProductosCategoria(categoria).then(productos => {
            _this.setState({
                productos
            })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.categoria !== prevProps.categoria) {
            this.setState({
                categoria: null,
                productos: []
            })
            this.leerCategoria()
        }

    }

    componentWillMount() {
        this.leerCategoria()
    }

    render() {
        return (
            <ProductCategoryComponent products={this.state.productos} category={this.state.categoria} leerProductos={this.leerProductos} />
        )
    }
}